<template>
    <span>
        <a-button size="small" type="primary" icon="check" v-on:click.prevent="showModal">Otras Solicitudes</a-button>
        <a-modal title="Solicitar Permisos"
                 :visible="modalVisible"
                 @ok="confirmar"
                 :confirmLoading="modalLoading"
                 @cancel="cancelar"
                 style="top: 20px;">
              <a-form :form="form" @submit="confirmar">
                  <g-dropdown endpoint="hierarchy_lookup"
                              label="Tipo Solicitud"
                              :formItemConfig="fiOptions"
                              :decorator="['tipo_solicitud', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="requestData.solicitud"
                              :disabled="modalLoading"
                              :selectedObj.sync="tipo_solicitud_seleccionado"></g-dropdown>

                  <g-dropdown endpoint="hierarchy_lookup"
                              label="Tipo"
                              :formItemConfig="fiOptions"
                              :decorator="['tipo_permiso', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="requestData.permiso"
                              :disabled="modalLoading"
                              :selectedObj.sync="tipo_permiso_seleccionado"></g-dropdown>

                  <g-dropdown endpoint="hierarchy_lookup"
                              label="Sub Tipo"
                              :formItemConfig="fiOptions"
                              :decorator="['sub_tipo_solicitud', { rules: [{ required: activarSubTipos, message: 'Valor requerido' }] }]"
                              :params="requestData.sub_tipo"
                              :disabled="modalLoading || !activarSubTipos"
                              :count.sync="cantidadSubTipos"></g-dropdown>

                  <a-form-item :label="$t('Fecha De Solicitud')" v-bind="fiOptions">
                      <a-date-picker style="width: 100%"
                                     v-decorator="['fecha_solicitud', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                                     :disabled="modalLoading"></a-date-picker>
                  </a-form-item>


                  <a-form-item label="Cantidad de Días" v-bind="fiOptions">
                      <a-input-number style="width: 100%"
                                      v-decorator="['cantidad_dias',
                                      { rules: [
                                            { required: activarDias, message: 'Valor requerido' },
                                            { type: 'integer', min: 1, message: 'El valor debe estar entre 1 y 99' },
                                            { type: 'integer', max: 99, message: 'El valor debe estar entre 1 y 99' },
                                        ]
                                      }
                                      ]"
                                      :disabled="modalLoading || !activarDias">
                      </a-input-number>
                  </a-form-item>

                  <a-form-item label="Hora Inicio" v-bind="fiOptions">
                        <a-time-picker :minuteStep="15" use12Hours format="h:mm a"
                                       v-decorator="['hora_inicio', {type:'object', rules: [{ required: activarHoras, message: 'Valor requerido' }] }]"
                                       placeholder="H. Inicio"
                                       style="width: 100%"
                                       :disabled="modalLoading || !activarHoras"
                        ></a-time-picker>
                  </a-form-item>
                  <a-form-item label="Hora Finl" v-bind="fiOptions">
                      <a-time-picker :minuteStep="15" use12Hours format="h:mm a"
                                     v-decorator="['hora_fin', {type:'object', rules: [{ required: activarHoras, message: 'Valor requerido' }] }]"
                                     placeholder="H. Fin"
                                     style="width: 100%"
                                     :disabled="modalLoading || !activarHoras"
                      ></a-time-picker>
                  </a-form-item>

                  <a-form-item label="¿Cómo lo va a recuperar?" v-bind="fiOptions" v-if="activarComoRecupera">
                          <a-textarea placeholder="¿Cómo lo va a recuperar?"
                                      autoSize
                                      v-decorator="['como_recupera']"
                                      style="text-transform: uppercase">
                          </a-textarea>
                  </a-form-item>

                  <a-form-item label="Observación" v-bind="fiOptions">
                          <a-textarea placeholder="Observación"
                                      autoSize
                                      v-decorator="['observaciones']"
                                      style="text-transform: uppercase">
                          </a-textarea>
                  </a-form-item>

                  <a-row>
                      <a-upload-dragger name="file" :beforeUpload="beforeUpload" :fileList="fileList"
                                        @change="fileChange">
                        <p class="ant-upload-drag-icon">
                            <a-icon type="inbox"/>
                        </p>
                        <p class="ant-upload-text">Clic o arrastrar y soltar en esta área para subir un archivo</p>
                        <p class="ant-upload-hint">
                            Solo es permitido seleccionar un archivo
                        </p>
                    </a-upload-dragger>
                  </a-row>

                  <a-alert type="error" :message="mensajeError" v-if="error"/>
              </a-form>
        </a-modal>
    </span>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import DateUtils from '@/util/DateUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        modalVisible: false,
        modalLoading: true,
        fecha_regreso: '',
        mensajeError: '',
        tipo_permiso_seleccionado: undefined,
        tipo_solicitud_seleccionado: undefined,
        cantidadSubTipos: 0,
        fileList: [],
        isInSubmit: false,
        error: false,
        form: this.$form.createForm(this, {
          name: 'solicitar',
          onFieldsChange: (_, changedFields) => {
            this.formularioActualizado(changedFields)
          }
        }),
        fiOptions: {
          'label-col': {span: 10},
          'wrapper-col': {span: 14},
          'has-feedback': true
        },
        fchkOptions: {
          'label-col': {span: 10},
          'wrapper-col': {offset: 10, span: 14},
          'has-feedback': true
        },
        requestData: {
          solicitud: {h_lookup_type: 'TIPO_SOLICITUD'},
          permiso: {h_lookup_type: 'TIPO_PERMISO', id_h_lookup_father: -1},
          sub_tipo: {h_lookup_type: 'SUBTIPO_SOLICITUD_PERMISO', id_h_lookup_father: -1}
        },
        isEdit: false,
        id: null,
        sub_tipo_solicitud: undefined,
        cont: 0
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.httpDownloadClient = this.httpClient.getNewInstance()
      this.httpDownloadClient.defaults.headers['Content-Type'] = 'multipart/form-data'
      this.$watch(
        () => {
          return this.$refs.listaSubTipo
        },
        (comp) => {
          this.activarSubTipos = comp.options.length > 0
        }
      )
    },
    methods: {
      cancelar () {
        if (this.modalLoading) return
        this.modalVisible = false
        this.modalLoading = false
        this.cont = 0
      },
      confirmar (e) {
        e && e.preventDefault()
        this.isInSubmit = true
        this.form.validateFields((err, values) => {
          if (!err) {
            this.modalLoading = true
            let request = {...values}
            request.fecha_solicitud = values.fecha_solicitud ? DateUtils.forBackEnd(values.fecha_solicitud) : ''
            request.hora_inicio = request.hora_inicio ? request.hora_inicio.format('HH:mm') : ''
            request.hora_fin = request.hora_fin ? request.hora_fin.format('HH:mm') : ''
            request.id = this.id
            let reqData = new FormData()
            for (let prop in request) {
              if (Object.prototype.hasOwnProperty.call(request, prop)) {
                if (!JsUtils.isEmpty(request[prop])) {
                  reqData.append(prop, request[prop])
                }
              }
            }
            if (this.fileList.length > 0) {
              reqData.append('adjunto', this.fileList[0])
            } else {
              let tiposQueRequierenArchivo = this.$getConfigValue('SS_PERMISO_ADJUNTO', '').split(',')
              if (tiposQueRequierenArchivo.length > 0) {
                if (tiposQueRequierenArchivo.includes(request.tipo_solicitud)) {
                  this.error = true
                  this.mensajeError = 'El archivo adjunto es requerido para el tipo de solicitud seleccionada.'
                  this.modalLoading = false
                  return
                }
              }
            }

            this.httpDownloadClient.post('ss/solicitar_permisos', reqData)
              .then((response) => {
                if (parseInt(response.data.resultado) === 0) {
                  this.error = true
                  this.mensajeError = response.data.mensaje
                } else {
                  this.error = false
                  this.mensajeError = ''
                  this.modalVisible = false
                  Mensajes.success('Correcto', response.data.mensaje)
                  this.form.resetFields()
                  this.$emit('success', {})
                }
              })
              .catch((error) => {
                Mensajes.error('Error', 'No fue posible realizar la solicitud.')
                this.error = true
                if (error.data) {
                  if (error.data.message) {
                    this.mensajeError = 'Error desconocido: ' + error.data.message
                  }
                  if (error.data.mensaje) {
                    this.mensajeError = error.data.mensaje
                  }
                } else {
                  this.mensajeError = 'Error desconocido'
                }
              })
              .then(() => {
                this.modalLoading = false
              })
          }
        })
        this.isInSubmit = false
        this.cont = 0
      },
      formularioActualizado (camposCambiados) {
        if (this.isInSubmit) return
        if (!JsUtils.isEmpty(camposCambiados.tipo_solicitud)) {
          let tmp = {...this.requestData.permiso}
          tmp.id_h_lookup_father = camposCambiados.tipo_solicitud.value
          this.requestData.permiso = tmp
          if (!this.isEdit) {
            this.form.setFieldsValue({
              tipo_permiso: undefined,
              sub_tipo_solicitud: undefined
            })
          }
        }
        if (!JsUtils.isEmpty(camposCambiados.tipo_permiso)) {
          let tmp = {...this.requestData.sub_tipo}
          tmp.id_h_lookup_father = camposCambiados.tipo_permiso.value
          this.requestData.sub_tipo = tmp
          this.form.setFieldsValue({
            sub_tipo_solicitud: undefined
          })
          this.cont++
          if (this.sub_tipo_solicitud && this.cont <= 2 && this.isEdit) {
            this.form.setFieldsValue({
              sub_tipo_solicitud: this.sub_tipo_solicitud
            })
          }
        }
      },
      showModal (record = null) {
        this.tipo_permiso_seleccionado = undefined
        this.modalVisible = true
        this.modalLoading = false
        this.error = false
        this.mensajeError = ''
        this.form.resetFields()
        this.fileList = []
        if (!this.$isEmpty(record)) {
          this.isEdit = true
          this.tipo_permiso_seleccionado = {equivalency: -1}
          this.requestData.permiso.id_h_lookup_father = record.type_req
          this.requestData.sub_tipo.id_h_lookup_father = record.type_permission
          this.tipo_permiso_seleccionado.equivalency = record.unidad_tiempo
          this.id = record.id
          let horaInicio = record.tiempo_inicio ? moment(record.tiempo_inicio, 'HH:mm') : null
          let horaFin = record.tiempo_fin ? moment(record.tiempo_fin, 'HH:mm') : null
          if (!this.activarHoras) {
            horaInicio = null
            horaFin = null
          }
          let cantidad = record.cantidad
          if (!this.activarDias) {
            cantidad = null
          }
          let subTipoSolicitud = record.sub_type_request
          if (!subTipoSolicitud) {
            subTipoSolicitud = null
          }
          this.sub_tipo_solicitud = subTipoSolicitud
          this.$nextTick(() => {
            this.form.setFieldsValue({
              tipo_solicitud: record.type_req,
              tipo_permiso: record.type_permission,
              fecha_solicitud: record.fecha_inicio ? moment(record.fecha_inicio).format('Y-MM-DD 00:00:00') : null,
              observaciones: record.observacion,
              hora_inicio: horaInicio,
              hora_fin: horaFin,
              cantidad_dias: cantidad
            })
          })
        }
      },
      beforeUpload (file) {
        return false
      },
      fileChange (info) {
        if (info.fileList.length > 0) {
          this.fileList = [info.file]
        } else {
          this.fileList = []
        }
      }
    },
    computed: {
      activarDias () {
        return JsUtils.isEmpty(this.tipo_permiso_seleccionado) ? false : (this.tipo_permiso_seleccionado.equivalency === 'DIA')
      },
      activarHoras () {
        return JsUtils.isEmpty(this.tipo_permiso_seleccionado) ? false : (this.tipo_permiso_seleccionado.equivalency === 'HORA')
      },
      activarSubTipos () {
        return !JsUtils.isEmpty(this.tipo_permiso_seleccionado) && this.cantidadSubTipos > 0
      },
      activarComoRecupera () {
        return this.activarHoras && this.$getConfigValue('MOSTRAR_COMO_RECUPERA_EN_DASHBOARD', false) === 'SI'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/SelfService/pages/Dashboard/BotonSolicitarPermisos.vue